const ACCESS_TOKEN_KEY = "access_token";

export function getStoredAccessToken(): string | null {
	return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setStoredTokens(accessToken: string): void {
	localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

export function clearStoredTokens(): void {
	localStorage.removeItem(ACCESS_TOKEN_KEY);
}
